import { TmcContextService } from './../../../../../../common/tmc-context.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Station } from '../../../../../../client/model/station';
import { PendingTaskState } from '../../../../../../widgets/control/transport-list/model';
import { PlannedTransport } from '../../../model/sac-client.model';
import { AppServerAPI } from '@sdbn/common';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-sac-station-tablet-planned-assignments',
  templateUrl: './sac-station-tablet-planned-assignments.component.html',
  styleUrls: ['./sac-station-tablet-planned-assignments.component.scss']
})
export class SACStationTabletPlannedAssignmentsComponent implements OnInit, OnDestroy {

  @Input() station: Station;

  selectedId: number;

  PendingTaskState = PendingTaskState;

  defaultVisibleColumns = [
    'hint', 'carrier', 'supplier', 'identifier', 'driver', 'visitStatusDict', 'string1', 'string2', 'start', 'reference', 'options', 'cargo', 'planningDate', 'messagingResources', 'filler'
  ];

  columnsToDisplay = this.defaultVisibleColumns;

  dataSource = new MatTableDataSource(new Array<PlannedTransport>());

  refreshSubscription: Subscription;

  constructor(
    private tmcContextService: TmcContextService,
    private appServerAPI: AppServerAPI
  ) { }

  ngOnInit(): void {

    if (this.refreshSubscription != null) {
      this.refreshSubscription.unsubscribe();
    }
    this.refreshSubscription = this.tmcContextService.stationUsagesUpdated$.subscribe(
      () => this.loadPlannedTransports()
    );

    this.loadPlannedTransports();

  }

  ngOnDestroy() {
    if (this.refreshSubscription != null) {
      this.refreshSubscription.unsubscribe();
      this.refreshSubscription = null;
    }
  }

  loadPlannedTransports() {

    this.appServerAPI.execute<any[]>(`/client/control/sac-client/find-planned-transports-for-station`, { id: this.station.id }).subscribe(
      plannedTransports => {

        let data = new Array<PlannedTransport>();

        for (const plannedTransport of plannedTransports) {
          data.push(new PlannedTransport(plannedTransport));
        }

        this.dataSource = new MatTableDataSource(data);

      }
    );

  }

}
